import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import SearchSection from './components/SearchSection';
import CategoryScroller from './components/CategoryScroller';
import SellerCards from './components/SellerCards';
import ComparisonTable from './components/ComparisonTable';
import SafetySection from './components/SafetySection';
import ArticleCards from './components/ArticleCards';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <SearchSection />
        <CategoryScroller />
        <SellerCards />
        <ComparisonTable />
        <SafetySection />
        <ArticleCards />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      {/* WebSite + Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'VigorBuy Spreadsheet Hub',
            url: SITE_URL,
            description: 'The ultimate resource for VigorBuy Spreadsheet links, trusted sellers, and QC-verified shopping guides.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${SITE_URL}/?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'VigorBuy Spreadsheet Hub',
            url: SITE_URL,
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg',
            description: 'The largest collection of VigorBuy Spreadsheet links, trusted sellers, and QC-verified products. Updated daily.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
    </>
  );
}